import React, { useState } from "react";
import ReactQuill from "react-quill";
import api from "../../../api";

import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

export function AddBanner({ getPosts, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [inputData, setInputData] = useState({
    description: "",
    img: "",
    format: "",
  });

  const handleSubmit = async () => {
    try {
      if (inputData?.img) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          imageTitle: inputData.img || "",
          imageFormat: inputData.format || "",
        };

        const signalResponse = await api.bannerCreate(payload);
        if (signalResponse?.success) {
          // alert("Stocks created successfully");
          setInputData({
            description: "",
            img: "",
            format: "",
          });
          setLoader(false);
          setSelectedImg([]);
          getPosts();
          setShow(false);
        } else {
          setLoader(false);
          alert("Something went wrong");
        }
      } else {
        setLoader(false);
        alert("Please add image");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  const onFileChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      for (let file of e.target.files) {
        formData.append("image", file);
      }
      const uploadRes = await api.uploadFile(formData);

      let sImage = [];
      var imgName = uploadRes[0].split(",");
      var imgFormat = uploadRes[1].split(",");
      for (let i = 0; i < imgName.length; i++) {
        sImage.push(
          `${process.env.REACT_APP_S3URL}/img_${imgName[i]}.${imgFormat[i]}`
        );
      }
      setSelectedImg(sImage);
      setInputData({
        ...inputData,
        img: uploadRes[0],
        format: uploadRes[1],
      });
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      console.log(e);
    }
  };

  return (
    <>
      <div className="add-stocks-container">
        <div className="add-stocks-card">
          <div className="card-header">
            <h3 className="card-title">Upload Banner</h3>
          </div>

          <div className="card-body">
            <div className="form-row">
              <div className="form-section">
                <label className="form-label">Upload Images</label>
                <div className="file-upload-area image-upload">
                  <label className="file-upload-label">
                    <input
                      name="file"
                      onChange={onFileChange}
                      accept="image/*"
                      type={"file"}
                      multiple
                      className="file-input"
                    />
                    <div className="upload-content">
                      <div className="upload-icon">
                        <i className="icon-upload"></i>
                      </div>
                      <div className="upload-text">
                        <h4>Click to upload images</h4>
                        <p>PNG, JPG, GIF up to 10MB each</p>
                      </div>
                      <div className="upload-button">Browse Files</div>
                    </div>
                  </label>
                </div>

                <div className="image-preview-container">
                  {selectedImg.length > 0 && (
                    <>
                      <div className="preview-header">
                        <span>Uploaded Images ({selectedImg.length})</span>
                      </div>
                      <div className="image-grid">
                        {selectedImg.map((val, key) => (
                          <div className="image-card" key={key}>
                            <img
                              className="preview-image"
                              src={val}
                              alt={`Uploaded ${key + 1}`}
                            />
                            <div className="image-overlay">
                              <span className="image-number">{key + 1}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="btn-primary"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <span className="spinner"></span>
                    Creating Banner...
                  </>
                ) : (
                  "Add Banner"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loader && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="loader-spinner">
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
            </div>
            <p className="loader-text">Creating your banner...</p>
          </div>
        </div>
      )}
    </>
  );
}
